// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { PrimaryButton, PrimaryLink } from '@/views/components/buttons';

// Utils
import { formatMessage } from '@/utils/i18n';

// Assets
import { ReactComponent as AnalyticsPieChart } from '@/images/analytics-pie-chart.svg?react';
import { Typography } from '@capintel/component-lib/typography';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  showMore: boolean;
  hasComparisons: boolean;
  onCreateAnalysis: () => void;
  onClickShow: () => void;
};

const Banner: React.FC<Props> = (props: Props) => {
  const { showMore, hasComparisons, onCreateAnalysis, onClickShow } = props;

  return (
    <div className={classNames('container', 'banner', { 'no-comparisons': !hasComparisons })}>
      <div className="info">
        <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
          {formatMessage('ComparisonHome.Banner.BuildTitle')}
        </Typography>
        <p>{formatMessage('ComparisonHome.Banner.BuildDescription')}</p>
      </div>

      <div className="cards">
        <div className="card card-drive">
          <AnalyticsPieChart className="card-img-top" />
          <div className="card-body">
            <h5 className="card-title">{formatMessage('ComparisonHome.Banner.Card1.Title')}</h5>
            <p className="card-text">{formatMessage('ComparisonHome.Banner.Card1.Description')}</p>
          </div>
        </div>

        <div className="card card-bring">
          <div className="card-body">
            <h5 className="card-title">{formatMessage('ComparisonHome.Banner.Card2.Title')}</h5>
            <p className="card-text">{formatMessage('ComparisonHome.Banner.Card2.Description')}</p>
          </div>
        </div>

        <div className="card card-personalize">
          <div className="card-body">
            <h5 className="card-title">{formatMessage('ComparisonHome.Banner.Card3.Title')}</h5>
            <p className="card-text">{formatMessage('ComparisonHome.Banner.Card3.Description')}</p>
          </div>
        </div>
      </div>

      <div className="actions">
        <PrimaryButton onClick={onCreateAnalysis}>
          {formatMessage(`${!hasComparisons ? 'Comparison.StartComparison' : 'ComparisonHome.Banner.GetStarted'}`)}
        </PrimaryButton>
        {hasComparisons && (
          <PrimaryLink onClick={onClickShow}>
            {formatMessage(`ComparisonHome.Show${showMore ? 'More' : 'Less'}`)}
            <i className={`icon-cheveron-${showMore ? 'down' : 'up'}`} />
          </PrimaryLink>
        )}
      </div>
    </div>
  );
};

export default Banner;
